if (!customElements.get('gift-wrap')) {
  class GiftWrap extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.form = this.querySelector('form');
      this.checkbox = this.querySelector('input[type="checkbox"]');
      this.submitBtn = this.querySelector('[type="submit"]');
      this.cartItems = this.closest('[data-cart-items]');
      
      this.onCartChangeListener = this.onCartChange.bind(this);
      document.addEventListener('theme:line-item:change', this.onCartChangeListener);

      this.checkbox.addEventListener('change', () => {
        if(this.checkbox.checked) {
          this.submitBtn.click();

          return;
        }

        this.removeGiftWrapProduct();
      });
    }

    disconnectedCallback() {
      document.removeEventListener('theme:line-item:change', this.onCartChangeListener);
    }

    onCartChange(e) {
      this.cartItems = this.closest('[data-cart-items]');

      if(e.detail.cartItemCount !== 1) return;

      this.removeGiftWrapProduct();
    }

    removeGiftWrapProduct() {
      const matchingLineItem = this.cartItems.querySelector(`[data-line-item-product-id="${this.dataset.productId}"]`);

      if(!matchingLineItem) return;

      setTimeout(() => {
        matchingLineItem.querySelector('[data-line-item-remove]').click();
      }, 500);
    }
  }

  customElements.define('gift-wrap', GiftWrap);
}
